export default __webpack_public_path__ + "static/media/password.e03d084e.svg";